var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "1600" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c("v-btn", _vm._g({ attrs: { color: "black", dark: "" } }, on), [
                _vm._v("Conversation")
              ])
            ]
          }
        }
      ]),
      model: {
        value: _vm.conversationDialog,
        callback: function($$v) {
          _vm.conversationDialog = $$v
        },
        expression: "conversationDialog"
      }
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        { staticStyle: { height: "500px" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "fill-height": "" } },
            [
              _c(
                "v-flex",
                { attrs: { "d-flex": "", md1: "" } },
                [
                  _c(
                    "v-card",
                    { attrs: { color: "white" } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "title", attrs: { primary: "" } },
                        [_vm._v("Scenes")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            "justify-center": "",
                            "text-align": "",
                            column: ""
                          }
                        },
                        _vm._l(_vm.scenes, function(scene, index) {
                          return _c(
                            "v-flex",
                            { key: index },
                            [
                              _c(
                                "v-btn",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.selectScene(scene)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(scene.title))]
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticStyle: { "margin-left": "21px", width: "600px" } },
                [
                  _c(
                    "v-flex",
                    { staticStyle: { height: "65%" } },
                    [
                      _c(
                        "v-flex",
                        {
                          staticStyle: { width: "250px", height: "50px" },
                          attrs: { "offset-lg4": "" }
                        },
                        [
                          _c("v-card-title", { staticClass: "headline" }, [
                            _vm._v("SCRIPT-SCENE #")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        {
                          staticStyle: { height: "75%" },
                          attrs: { color: "white" }
                        },
                        [
                          _c("chat-area", {
                            attrs: { nodeId: _vm.nodeId, storyID: _vm.storyID }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticStyle: { top: "100px", height: "20%" } },
                    [
                      _c("bottom-block", {
                        attrs: {
                          editor: _vm.editor,
                          timelineContent: _vm.timelineContent,
                          timelineId: _vm.timelineId
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticStyle: {
                        "margin-top": "10px",
                        width: "150px",
                        height: "15%"
                      }
                    },
                    [
                      _c("v-card-actions", [
                        _c("div", { staticClass: "flex-grow-1" })
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticStyle: {
                    "margin-left": "21px",
                    "margin-right": "15px",
                    "margin-top": "50px"
                  }
                },
                [
                  _c("prev-condition", {
                    attrs: {
                      nodeId: _vm.nodeId,
                      diagramData: _vm.diagramData,
                      timelineContent: _vm.timelineContent
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0e9b1e0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0e9b1e0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-edit-view/conversation/conversation.vue
// module id = null
// module chunks = 